module.exports = __webpack_public_path__ + "static/media/save.788e5a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/save.png
// module id = 1040
// module chunks = 0